import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import axios from 'axios';
import { About, Header, Footer } from './components';
import ScrollManager from './components/ScrollManager';

import {
  CaseStudies,
  LoginPage,
  MainPage,
  SignIn,
  SignUp,
  ResetPasswordRequest,
  ResetPassword,
  ErrorPage,
  AccountManagement,
  Downloads,
  Support,
  NotFoundPage,
  Unauthorized,
  Features,
  Sla,
} from './pages';

import { BdcCaseStudy, PrattCaseStudy, AFRLCaseStudy } from './pages/case_studies';
import UseCasePage from './pages/use_cases/UseCasePage';

// Set withCredentials to true globally
axios.defaults.withCredentials = true;

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#135c72',
      dark: '#0b3848',
      light: '#2c8197',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ba6b2e',
      dark: '#7d4218',
      light: '#d89050',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f6f7f4',
      paper: '#ffffff',
    },
    text: {
      primary: '#172126',
      secondary: '#536268',
    },
    divider: 'rgba(23, 33, 38, 0.12)',
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: 'Red Hat Display, Arial, sans-serif',
    h1: {
      fontWeight: 800,
      letterSpacing: 0,
    },
    h2: {
      fontWeight: 800,
      letterSpacing: 0,
    },
    h3: {
      fontWeight: 750,
      letterSpacing: 0,
    },
    h4: {
      fontWeight: 750,
      letterSpacing: 0,
    },
    h5: {
      fontWeight: 700,
      letterSpacing: 0,
    },
    button: {
      fontWeight: 750,
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});


function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <AuthProvider>
          <Router>
            <ScrollManager />
            <Header />
            <div className="content">
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/signin" element={<SignIn />} />
                <Route path="/error" element={<ErrorPage />} />
                <Route path="/reset-password-request" element={<ResetPasswordRequest />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/" element={<MainPage />} />
                <Route path="/sla" element={<Sla />} />
                <Route path="/features" element={<Features />} />
                <Route path="/about-us" element={<About />} />
                <Route path="/case-studies" element={<CaseStudies />} />
                <Route path="/case-studies/pratt-whitney" element={<PrattCaseStudy />} />
                <Route path="/case-studies/afrl" element={<AFRLCaseStudy />} />
                <Route path="/case-studies/bdc" element={<BdcCaseStudy />} />
                <Route path="/use-cases/:slug" element={<UseCasePage />} />
                <Route element={<ProtectedRoute />}>
                  <Route path="/downloads" element={<Downloads />} />
                  <Route path="/support" element={<Support />} />
                  <Route path="/account" element={<AccountManagement />} />
                </Route>
                <Route path="*" element={<NotFoundPage />} /> {/* Catch-all route for 404 */}
              </Routes>
            </div>
          </Router>
        </AuthProvider>
        <Footer />
      </div>
    </ThemeProvider>
  );
}


export default App;
